import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { PlaybookCommunicationService } from "../shared/services/playbook-communication.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import {
  Modalconfig,
  DefaultLanguageId,
  serverUrl,
  devicePixelRatio,
  ContentBlockType,
} from "src/app/shared/constants";
import {
  cloneDeep,
  debounce,
  forEach,
  isUndefined,
  reject,
  each,
  findIndex,
  merge,
  filter,
} from "lodash";
import { Observable, Subscription, timer } from "rxjs";
import { SessionStorageService } from "src/app/shared/services/session-storage/session-storage.service";
import {
  sessionProfile,
  profileRoles,
} from "src/app/shared/interfaces/sessionStorageModel";
import { moveItemInArray, CdkDragDrop } from "@angular/cdk/drag-drop";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import {
  Container,
  ContainerType,
  CopyContentExists,
  PlaybookManifest,
  ResponseDraftStatus,
  SectionsForPageViewModel,
} from "src/app/shared/model/container.models";
import { AddPageComponent } from "../shared/components/add-page/add-page.component";
import { RatingsComponent } from "src/app/shared/components/ratings/ratings.component";
import { ApplyPageTemplateComponent } from "../shared/components/apply-page-template/apply-page-template.component";
import { CopyPageTemplateComponent } from "../shared/components/copy-page-template/copy-page-template.component";
import { CommunicationService } from "src/app/shared/services/communication/communication.service";
import { MessageService } from "src/app/shared/services/message/message.service";
import { UtilService } from "../shared/services/utils/util.service";
import { SelectTranslationComponent } from "src/app/shared/components/translation-language/translation-language.component";
import { PlaybookCustomCssComponent } from "../shared/components/playbook-custom-css/playbook-custom-css.component";
import { RatingData } from "src/app/shared/model/resource-model";
import $ from "jquery";
import { ConfirmationModelComponent } from "src/app/shared/components/confirmation-model/confirmation-model.component";
import { ApplyDraftComponent } from "../shared/components/apply-draft/apply-draft.component";
import { retry, switchMap } from "rxjs/operators";
import * as screenfull from "screenfull";
import { isFirefox, isEdge } from '../../shared/utils/browser.util';
import { UndoRedoComponent } from "../shared/components/undo-redo/undo-redo.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { LocalStorageService } from "src/app/shared/services/local-storage/local-storage.service";
import { AuthService } from "src/app/core/authentication/auth.service";
import { LocalStorageService as storageServices } from "ngx-webstorage";
import { SendIframeUrlService } from "src/app/shared/services/send-iframe-url/send-iframe-url.service";
import { PlaybookToastService } from "../shared/services/playbook-toast/playbook-toast.service";

@Component({
    selector: "app-container",
    templateUrl: "./container.component.html",
    styleUrls: ["./container.component.scss"],
    standalone: false
})
export class ContainerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input("containers") container: Container;
  @Input("playbookId") playbookId;
  @Input("allowConversation") allowConversation;
  @Input("companyId") companyId;
  @Input("isCustomCss") isCustomCss;
  @Input() isParentPageInDraftMode = false;
  @ViewChild("contentBox") contentBox: ElementRef;
  defaultLanguageId = DefaultLanguageId;
  public resourceCounts = 0;
  public isCurrentPageInDraftMode = false;
  //
  private bsModalSearchPlaybook: BsModalRef;
  private bsRatingsModal: BsModalRef;
  //
  private addPageModalRef: BsModalRef;
  //
  private applyPageTempRef: BsModalRef;
  private copyPageTempRef: BsModalRef;
  private customCssRef: BsModalRef;
  private bsTranslationLanguageModal: BsModalRef;
  //
  private scrollEnable = true;
  private throttle;
  private subscribed = null;
  private pageIdSubscribed: Subscription = null;
  private sectionIdSubscriber: Subscription = null;
  private contRatingsSubscription: Subscription;
  private modalSubscription: Subscription[] = [];
  private navContainerUpdateSubscription: Subscription;
  private showContentBoxSubscription: Subscription;
  public playbookLanguages: any;
  private selectedPageId;
  private selectedSectionId;
  public updateSearchResult;
  loggedInProfile: sessionProfile;
  isServerProcess = false;
  private routeSubscription: Subscription;
  public list = {
    sections: [],
    pages: [],
    draftSection: [],
    draftPages: [],
  };
  public contentBoxShow = false;
  public isCopyPasteContentExist = new CopyContentExists();
  public isContentBoxOpened = false;
  public profileRolesEnum = profileRoles;
  public screenfull = screenfull;
  draggableWithDragText = {
    type: ContentBlockType.Text,
  };
  draggableWithDragTab = {
    type: ContentBlockType.Tabs,
  };
  draggableWithDragImage = {
    type: ContentBlockType.Image,
  };
  draggableWithDragAudio = {
    type: ContentBlockType.Audio,
  };
  draggableWithDragVideo = {
    type: ContentBlockType.Video,
  };
  draggableWithDragChallenge = {
    type: ContentBlockType.Challenge,
  };
  draggableWithDragCopyPaste = {
    type: ContentBlockType.CopyPaste,
  };
  vBuilderRedirectURl: string;
  templateUrl: string;
  languageId: number;
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  draftModalRef: BsModalRef;
  draftModalSubsciber: Subscription;
  modalRef: BsModalRef;
  private checkDraftStatus$: Observable<any>;
  private checkDraftStatusSubscription$: Subscription;
  public isFireFox = isFirefox();
  public isEdge = isEdge();
  tabId: number;
  pageFrom;
  showMobileEditor = false;
  deviceInfo = null;
  isMobile: boolean = false;
  isDesktopDevice: boolean;
  inMobileEditor = false;
  videoListPerSection = [];
  serverUrl = serverUrl;
  devicePixelRatio = devicePixelRatio;
  contentRow: any;

  private getUpdatingTextBlockSub: Subscription = null;
  private getUpdatingTabSub: Subscription = null;

  constructor(
    private router: Router,
    private commonHttpService: CommonHttpService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private commService: PlaybookCommunicationService,
    private sessionStorageService: SessionStorageService,
    private communicationService: CommunicationService,
    private utilService: UtilService,
    private messageService: MessageService,
    private deviceService: DeviceDetectorService,
    private localStorageService: LocalStorageService,
    private authService: AuthService,
    private localSt: storageServices,
    private sendIframeUrlService: SendIframeUrlService,
    private playbookToastService: PlaybookToastService
  ) {
    this.deviceService.setDeviceInfo(window.navigator.userAgent);
    this.checkDeviceType();
  }

  checkDeviceType() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  searchText: string = "";
  ngOnInit() {
    this.loggedInProfile =
      this.sessionStorageService.getLoggedInProfileDetail();
    this.languageId =
      +this.activatedRoute.snapshot.queryParams.languageId ||
      this.defaultLanguageId;
    this.vBuilderRedirectURl =
      this.activatedRoute.snapshot.queryParams.r || null;
    this.tabId = +this.localStorageService.getLocalStogareByKey("tabId");
    this.templateUrl =
      this.activatedRoute.snapshot.queryParams.templateUrl || null;
    this.searchText =
      this.activatedRoute.snapshot.queryParams.searchText || null;

    this.pageFrom = +this.activatedRoute.snapshot.queryParams.pageFrom || null;
    this.assignCurrentPageDraft();
    // to set page title according to selected section on initial loading
    this.routeSubscription = this.activatedRoute.params.subscribe((data) => {
      if (data.sectionId) {
        if (this.container.containers) {
          this.container.containers.forEach((container: Container) => {
            if (container.id === data.sectionId) {
              document.title = container.title;
            }
          });
        }
      }
    });
    this.throttle = debounce(this.onScrollContent, 10);

    /**
     * To seperate sections and pages from containers
     */
    if (this.container.containers && this.container.containers.length > 0) {
      this.seperateContainer();
      this.pageIdSubscribed = this.commService
        .getCurrentPageId()
        .subscribe((pageId) => {
          this.selectedPageId = pageId;
        });
      this.sectionIdSubscriber = this.commService
        .getCurrentSectionId()
        .subscribe((sectionId) => {
          this.selectedSectionId = sectionId;
        });
    }

    if (this.commService.currentSectionId != null) {
      this.selectedSectionId = this.commService.currentSectionId;
    }
    if (this.commService.currentPageId != null) {
      this.selectedPageId = this.commService.currentPageId;
    }
    this.isCopyPasteContentExist = this.commService.getCopyContentExists();

    this.getResourcesCounts();

    // To open container ratings modal when '/ratings' url is hit directly
    this.contRatingsSubscription = this.communicationService
      .getContRatingsStatus()
      .subscribe((status) => {
        if (status) {
          this.openRatingsModal();
        }
      });

    /**
     * Subscriber to handle edit and deletion of section from nav
     */

    this.navContainerUpdateSubscription = this.commService
      .getNavContainerUpdate()
      .subscribe((container) => {
        if (this.container.id === container.container.parentContainerId) {
          if (container.container.isDeleted) {
            this.container.containers = reject(
              this.container.containers,
              (cont) => {
                return cont.id === container.container.id;
              }
            );
            if (container.isSection && container.deleteDraftSection) {
              this.container.containers = reject(
                this.container.containers,
                (eachCont) => eachCont.refContainerId === container.container.id
              );
            }
            this.seperateContainer();
          } else {
            this.editContainer(container.container);
          }
        }
      });

    // to handle direct routes for pagetemplate modals
    if (window.location.pathname.indexOf("pagetemplate/choose") !== -1) {
      this.openApplyTemplateModal();
    } else if (window.location.pathname.indexOf("pagetemplate") !== -1) {
      this.openCopyTemplateModal();
    }
    this.commService.getPlaybookLanguages().subscribe((playbookLanguages) => {
      this.playbookLanguages = playbookLanguages;
    });

    this.showContentBox();
    this.isServerProcessFunc();
    this.addVideoContentsPerSecList();
    this.playbookNavigationRedirect();

    this.getUpdatingTextBlockSub = this.commService
      .getUpdatingTextBlock()
      .subscribe((loading: boolean) => {
        this.updatingTextBlock = loading;
        this.displayChangesSaved();
      });

    this.getUpdatingTabSub = this.commService
      .getUpdatingTab()
      .subscribe((loading: boolean) => {
        this.updatingTab = loading;
        this.displayChangesSaved();
      });
  }

  private updatingTextBlock: boolean = false;
  private updatingTab: boolean = false;

  addVideoContentsPerSecList() {
    this.container.containers.forEach((cont, index) => {
      if (!cont.isDraftMode) {
        this.videoListPerSection.push({
          id: cont.id,
          title: cont.title,
          containerId: cont.parentContainerId,
          contentBlocsList: [],
        });
        cont.contentColumns.forEach((column) => {
          column.contentRows.forEach((row) => {
            if (row.contentColumns.length) {
              this.checkContentCols(row.contentColumns, index);
            }
            if (
              row.contentBlock &&
              row.contentBlock.type === 5 &&
              row.contentBlock.videoBlock
            ) {
              this.addVideoContentBlock(row, index);
            }
            if (row.contentBlock && row.contentBlock.type === 3) {
              this.addTabVideoBlock(row, index);
            }
          });
        });
      }
    });
    this.videoListPerSection = this.videoListPerSection.filter(
      (contSect) => contSect.contentBlocsList.length
    );
  }

  checkContentCols(contentCols, index) {
    contentCols.forEach((column) => {
      column.contentRows.forEach((row) => {
        if (row.contentColumns.length) {
          this.checkContentCols(row.contentColumns, index);
        }
        if (
          row.contentBlock &&
          row.contentBlock.type === 5 &&
          row.contentBlock.videoBlock
        ) {
          this.addVideoContentBlock(row, index);
        }

        if (row.contentBlock && row.contentBlock.type === 3) {
          this.addTabVideoBlock(row, index);
        }
      });
    });
  }

  addVideoContentBlock(row, index) {
    row.contentBlock.videoBlock.activity = null;
    const placeHolderImageId = row.contentBlock.videoBlock
      ? row.contentBlock.videoBlock.placeHolderImageId
      : null;
    if (placeHolderImageId) {
      const token = this.authService.token();
      row.contentBlock.videoBlock.thumbNailStyle = {
        "background-image": `url(${serverUrl}/api/Assets/GetPlaybookTilesImage/${placeHolderImageId}?width=1024&ratio=${this.devicePixelRatio}&access_token=${token})`,
        width: "100%",
      };
    }
    this.videoListPerSection[index].contentBlocsList.push(row.contentBlock);
  }

  addTabVideoBlock(row, index) {
    if (row.contentBlock.tabsBlock.elements.length) {
      row.contentBlock.tabsBlock.elements.forEach((tabElem) => {
        if (tabElem.container.contentColumns.length) {
          tabElem.container.contentColumns.forEach((col) => {
            col.contentRows.forEach((colRow) => {
              if (colRow.contentColumns.length) {
                this.checkContentCols(colRow.contentColumns, index);
              }
              if (
                colRow.contentBlock &&
                colRow.contentBlock.type === 5 &&
                colRow.contentBlock.videoBlock
              ) {
                colRow.contentBlock.videoBlock.activity = null;
                const placeHolderImageId =
                  colRow.contentBlock.videoBlock.placeHolderImageId;
                if (placeHolderImageId) {
                  const token = this.authService.token();
                  colRow.contentBlock.videoBlock.thumbNailStyle = {
                    "background-image": `url(${serverUrl}/api/Assets/GetPlaybookTilesImage/${placeHolderImageId}?width=1024&ratio=${this.devicePixelRatio}&access_token=${token})`,
                    width: "100%",
                  };
                }
                this.videoListPerSection[index].contentBlocsList.push(
                  colRow.contentBlock
                );
              }
            });
          });
        }
      });
    }
  }

  changeTabFunc(event) {
    const selectedSection = this.list.sections.filter(
      (section) => section.id === event
    )[0];
    document.title = selectedSection.title;
    this.commService.sendCurrentSectionId(selectedSection.id);
    this.setPageSectionsOn(selectedSection.id);
  }

  ngAfterViewInit() {
    const self = this;

    /**
     * Malihu-scroll bar is removed and instead of that register a scroll event of the container.
     */
    if (this.tabId) {
      this.scrollToTab(this.tabId);
    } else {
      $(`#content-${this.container.id}`).on("scroll", () => {
        if (self.scrollEnable === true) {
          this.throttle($(`#content-${this.container.id}`));
        }
      });
      /** Handle deep-link scroll; IDs/state are initialized in ngOnInit. */
      this.mobileScrollToSection(this.selectedSectionId);
      if (this.selectedPageId === this.container.id) {
        let SelectedElement = document.getElementById(
          "section-" + this.selectedSectionId
        );

        if (SelectedElement !== null) {
          setTimeout(() => {
            SelectedElement = document.getElementById(
              "section-" + this.selectedSectionId
            );
            this.scrollEnable = false;
            $(`#content-${this.container.id}`).animate(
              { scrollTop: this.getSectionTop(this.selectedSectionId) },
              300,
              () => {
                this.scrollEnable = true;
              }
            );
          }, 100);
        }
      }
    }
  }

  assignCurrentPageDraft() {
    const jsonDraft = JSON.parse(localStorage.getItem("isDraftMode"));
    const draftStatus: any = jsonDraft
      ? jsonDraft
      : this.commService.getDraftStatusByPageId(this.container.id);
    if (draftStatus.pageId === this.container.id) {
      this.isCurrentPageInDraftMode = draftStatus.isPageDraftMode;
      this.container.isCurrentPageInDraftMode = draftStatus.isPageDraftMode;
      localStorage.removeItem("isDraftMode");
      this.commService.setDraftStatus({
        pageId: this.container.id,
        isPageDraftMode: false,
      });
    } else {
      this.isCurrentPageInDraftMode = this.isParentPageInDraftMode;
      this.container.isCurrentPageInDraftMode = this.isParentPageInDraftMode;
    }
  }

  mobileScrollToSection(sectionId) {
    const isSearchOpened = JSON.parse(
      localStorage.getItem("isSearchOpenedEditor")
    );
    if (
      sectionId &&
      this.inMobileEditor &&
      document.getElementById("editor-title-" + sectionId) &&
      isSearchOpened
    ) {
      document.getElementById("editor-title-" + sectionId).scrollIntoView();
    }
  }

  playbookNavigationRedirect() {
    this.commService.getSamePageRedirect().subscribe((sectionId) => {
      if (sectionId) {
        setTimeout(() => {
          this.mobileScrollToSection(sectionId);
        }, 100);
      }
    });
  }

  showContentBox() {
    this.showContentBoxSubscription = this.commService
      .getSelectedContentBox()
      .subscribe((isContentBoxShow) => {
        this.contentBoxShow = isContentBoxShow;
        this.commService.sendSelectedRowBox(!this.contentBoxShow);
      });
  }
  /**
   * To seperate sections and pages to display
   */
  seperateContainer() {
    this.list.sections = this.container.containers.filter((x) => {
      return x.type === 2 && !x.isDraftMode;
    });
    this.list.pages = this.container.containers.filter((x) => {
      return x.type === 1 && !x.isDraftMode;
    });

    this.list.draftSection = this.container.containers.filter(
      (x) => x.type === 2 && x.isDraftMode && !x.isDeleted
    );

    this.list.draftPages = this.container.containers.filter(
      (x) => x.type === 1 && x.isDraftMode && !x.isDeleted
    );
    this.commService.setDraftSectionList(this.list.draftSection);
  }
  /**
   * To set selected section in sidebar
   */
  setPageSectionsOn(selectedId) {
    this.container.containers.forEach((cont, index) => {
      if (cont.type === 2 && cont.id === selectedId) {
        cont.on = true;
        document.title = cont.title;
      } else if (cont.type === 2) {
        cont.on = false;
      }
    });
    if (this.selectedPageId === this.container.id) {
      this.ref.detectChanges();
    }
  }

  /**
   * To check which section in viewport and set its section on along with change of location in browser url.
   */
  private onScrollContent = (elem) => {
    const x = elem.find("section.content_section");

    for (const el of x) {
      const selected = +el.getAttribute("id").split("section-")[1];
      const top = el.getBoundingClientRect().top;
      if (
        top - 44 >= 0 ||
        el.scrollHeight >= window.innerHeight - Math.ceil(top)
      ) {
        if (selected !== this.selectedSectionId) {
          this.commService.sendCurrentSectionId(selected);
          this.setPageSectionsOn(selected);
          this.location.replaceState(
            `/playbookeditor/${this.playbookId}/page/${
              this.container.id
            }/section/${selected}?languageId=${this.languageId}${
              this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
            }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
              this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
            }${this.searchText ? `&searchText=${this.searchText}` : ""}`
          );
          this.sendIframeUrlService.sendUrlToParent(this.location.path());
          return;
        }
      }
    }
  };

  scrollToTab(tabId) {
    if (!tabId) {
      return;
    }
    const elmnt = document.getElementById("tab-" + tabId);
    if (!elmnt) {
      return;
    }
    elmnt.scrollIntoView();
  }

  /**
   * To scroll on top of container when clicked on name of container
   */
  scrollToTop(containerId) {
    const id = containerId ? containerId : this.container.id;
    const scrollElement = document
      .getElementById("content-" + id)
      .querySelectorAll(".content_section")[0];
    if (!isUndefined(scrollElement)) {
      const scrollId = +scrollElement.id.split("section-")[1];
      this.location.go(
        `/playbookeditor/${
          this.playbookId
        }/page/${id}/section/${scrollId}?languageId=${this.languageId}${
          this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
        }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
          this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
        }`
      );
      this.scrollEnable = false;
      $(`#content-${id}`).animate(
        { scrollTop: this.getSectionTop(scrollId) },
        300,
        () => {
          this.scrollEnable = true;
        }
      );
      this.setPageSectionsOn(scrollId);
      this.commService.sendCurrentSectionId(scrollId);
      this.sendIframeUrlService.sendUrlToParent(this.location.path());
    } else {
      this.location.go(
        `/playbookeditor/${this.playbookId}/page/${id}?languageId=${
          this.languageId
        }${this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""}${
          this.templateUrl ? "&templateUrl=" + this.templateUrl : ""
        }${this.pageFrom ? "&pageFrom=" + this.pageFrom : ""}`
      );
      this.sendIframeUrlService.sendUrlToParent(this.location.path());
    }
    if (id !== this.selectedPageId) {
      this.commService.sendCurrentPageId(id);
    }
  }

  /**
   * To set section to top in content for reading on click of section link in sidebar
   */
  showSection(cont: Container) {
    document.title = cont.title;
    if (cont.parentContainerId === this.selectedPageId) {
      this.location.replaceState(
        `/playbookeditor/${this.playbookId}/page/${this.container.id}/section/${
          cont.id
        }?languageId=${this.languageId}${
          this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
        }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
          this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
        }`
      );
      this.mobileScrollToSection(this.selectedSectionId);
      this.sendIframeUrlService.sendUrlToParent(this.location.path());
    } else {
      this.commService.sendCurrentPageId(this.container.id);
      this.location.go(
        `/playbookeditor/${this.playbookId}/page/${
          cont.parentContainerId
        }/section/${cont.id}?languageId=${this.languageId}${
          this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
        }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
          this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
        }`
      );
      this.sendIframeUrlService.sendUrlToParent(this.location.path());
    }
    this.commService.sendCurrentSectionId(cont.id);
    this.localStorageService.clearLocalStogareByKey("tabId");
    this.scrollEnable = false;
    $(`#content-${this.container.id}`).animate(
      { scrollTop: this.getSectionTop(cont.id) },
      300,
      () => {
        this.scrollEnable = true;
      }
    );
    setTimeout(() => {
      this.setPageSectionsOn(cont.id);
    });
  }

  /**
   * This will return the top position of the section.
   */
  getSectionTop(sectionId) {
    const section = $("section#section-" + sectionId);
    if (section.offset()) {
      const sectionTop = section.offset().top;
      const contentTop = $("#content-" + this.container.id).scrollTop();
      let top = 0;
      if ($(".card-playbook").offset()) {
        top = $(".card-playbook").offset().top;
      }
      const scrollTop = sectionTop + contentTop - 44 - top;
      return scrollTop;
    }
    return null;
  }

  /**
   * To turn open children pages of perticular page
   */
  setContainer(containerId, isParent) {
    $(".text-editor-menu-bar").hide();
    this.localStorageService.clearLocalStogareByKey("tabId");
    if (containerId == null) {
      document.title = this.commService.Playbook.title;
      this.location.go(
        `/playbookeditor/${this.playbookId}?languageId=${this.languageId}${
          this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
        }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
          this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
        }`
      );
      this.sendIframeUrlService.sendUrlToParent(this.location.path());
    } else {
      if (isParent && containerId) {
        this.scrollToTop(containerId);
      }
    }
    if (!isParent) {
      this.setPageSectionsOn(-1);
      this.commService.sendCurrentPageId(containerId);
      this.commService.sendCurrentSectionId(null);
    }
    this.localSt.store("isVideoPlaylist", false);
  }

  /**
   * To get resource count for selected container resources
   */
  getResourcesCounts() {
    if (this.container.resourceFolders) {
      this.container.resourceFolders.map((folder) => {
        folder.resources.map((resource) => {
          // For Links
          if (
            resource.type === 1 &&
            resource.linkUrl &&
            resource.linkUrl.toString().trim() !== ""
          ) {
            this.resourceCounts++;
          } else if (
            (resource.type === 2 || resource.type === 0) &&
            resource.asset &&
            resource.assetId
          ) {
            this.resourceCounts++;
          }
        });
      });
    }
    this.container.resources.map((resource) => {
      // For Links
      if (
        resource.type === 1 &&
        resource.linkUrl &&
        resource.linkUrl.toString().trim() !== ""
      ) {
        this.resourceCounts++;
      } else if (
        (resource.type === 2 || resource.type === 0) &&
        resource.asset &&
        resource.assetId
      ) {
        this.resourceCounts++;
      }
    });
  }

  /**
   * To toggle resource drawer for this container
   */
  toggleDrawer() {
    this.commService.ToggleResourcesOn();
    this.commService.sendSelectedContentBox(false);
    this.commService.sendSelectedContentBlockId(null);
    this.commService.sendSelectedRowId(null);
  }

  /**
   * To redirect to editor module
   */
  redirectToViewer() {
    setTimeout(() => {
      const route = `${window.location.pathname.replace(
        "/playbookeditor",
        "/playbook"
      )}?languageId=${this.languageId}${
        this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
      }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}`;
      this.router.navigateByUrl(route);
    }, 200);
  }

  /**
   * To open the language selection modal
   */
  openLanguageModal() {
    const initialState = {
      playbookLanguages: this.playbookLanguages,
      languageId: this.languageId,
      playbookId: this.playbookId,
    };
    this.bsTranslationLanguageModal = this.modalService.show(
      SelectTranslationComponent,
      Object.assign(
        { initialState },
        { class: "custom-modal translation-box" },
        Modalconfig
      )
    );
    // to change url when language modal is opened
    const path = window.location.pathname;
    if (path.indexOf("selectTranslation") === -1) {
      const url = `${path}/selectTranslation${window.location.search}`;
      this.location.go(url);
      this.sendIframeUrlService.sendUrlToParent(url);
    }
  }

  openRatingModalFunc() {
    this.openRatingsModal();
  }

  /**
   * To open ratings modal
   */
  openRatingsModal() {
    let ratingsData: RatingData;
    this.commonHttpService
      .post({
        uri: "/api/Ratings/GetAllRatings",
        object: {
          id: this.container.id,
          type: 0,
          playbookId: this.playbookId,
          languageId: this.languageId,
          profileId: this.loggedInProfile.id,
          companyId: this.companyId,
        },
      })
      .subscribe((response: RatingData) => {
        ratingsData = response;

        // Get the live sections to display on the
        let sections: Container[];
        if (
          this.container &&
          this.container.containers &&
          this.container.containers.length > 0
        ) {
          sections = filter(
            this.container.containers,
            (container: Container) => {
              return (
                !container.isDraftMode &&
                !container.isDeleted &&
                container.type == ContainerType.Section
              );
            }
          );
        }

        const initialState = {
          ratingsData,
          playbookId: this.playbookId,
          languageId: this.languageId,
          profileId: this.loggedInProfile.id,
          role: this.loggedInProfile.role,
          containerId: this.container.id,
          resourceId: null,
          companyId: this.companyId,
          inMobileEditor: this.inMobileEditor,
          type: 0,
          sections,
        };
        this.bsRatingsModal = this.modalService.show(
          RatingsComponent,
          Object.assign(
            { initialState },
            { class: "custom-modal" },
            Modalconfig
          )
        );

        // To change URL when opening the modal from icon click
        const path = window.location.pathname;
        if (path.indexOf("ratings") === -1) {
          const languageUrl = window.location.href.split("?");
          const url = `${path}/ratings?${languageUrl[1]}`;
          this.location.go(url);
          this.sendIframeUrlService.sendUrlToParent(url);
        }
      });
  }

  onContainerItemDrop(e: CdkDragDrop<any[]>) {
    const items = [];
    each(e.container.element.nativeElement.querySelectorAll("li"), (page) => {
      items.push(+page.id.replace("page-", ""));
    });
    moveItemInArray(items, e.previousIndex, e.currentIndex);
    const orderObj = items.map((id, index) => {
      return Object.assign({}, { id, order: index });
    });
    const reqObj = {
      playbookId: this.commService.Playbook.id,
      languageId: this.languageId,
      companyId: this.commService.Playbook.companyId,
      type: 1,
      orders: orderObj,
    };
    let list = cloneDeep(this.list);
    if (!this.container.isCurrentPageInDraftMode) {
      forEach(this.list.pages, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    } else {
      forEach(this.list.draftPages, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    }
    this.commonHttpService
      .post({
        uri: "/api/Containers/ReOrderContainers",
        object: reqObj,
      })
      .subscribe(
        (res) => {
          list = null;
        },
        (error) => {
          this.list = list;
          list = null;
        }
      );
  }

  /**
   * To handle reorder of containers
   * @param e cdkDragDrop event handler
   */
  onSectionItemDrop(e: CdkDragDrop<any[]>) {
    const items = [];
    each(e.container.element.nativeElement.querySelectorAll("li"), (page) => {
      items.push(+page.id.replace("section-", ""));
    });
    moveItemInArray(items, e.previousIndex, e.currentIndex);
    const orderObj = items.map((id, index) => {
      return Object.assign({}, { id, order: index });
    });
    const reqObj = {
      playbookId: this.commService.Playbook.id,
      languageId: this.languageId,
      companyId: this.commService.Playbook.companyId,
      type: 1,
      orders: orderObj,
    };
    let list = cloneDeep(this.list);
    if (!this.container.isCurrentPageInDraftMode) {
      forEach(this.list.sections, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    } else {
      forEach(this.list.draftSection, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    }
    this.commonHttpService
      .post({
        uri: "/api/Containers/ReOrderContainers",
        object: reqObj,
      })
      .subscribe(
        (res) => {
          list = null;
        },
        (error) => {
          this.list = list;
          list = null;
        }
      );
  }

  /**
   * To handle add section popup
   */
  addSection() {
    const container = new Container();
    container.type = 2;
    container.iconClass = null;
    container.parentContainerId = this.container.id;
    const initialState = {
      container,
      verb: "Add",
      playbookId: this.commService.Playbook.id,
      companyId: this.commService.Playbook.companyId,
      profileId: this.loggedInProfile.id,
      pageId: this.container.id,
      draftMode: this.isCurrentPageInDraftMode,
      languageId: this.languageId,
      templateUrl: this.templateUrl,
    };
    this.addPageModalRef = this.modalService.show(
      AddPageComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );

    this.modalSubscription.push(
      this.addPageModalRef.content.addContainer.subscribe((data) => {
        this.container.containers.push(data);
        this.seperateContainer();
        this.unsubscribeModelsSub();
      }),
      this.addPageModalRef.content.pasteContainer.subscribe(async (data) => {
        this.getPlaybookManifest();
        this.unsubscribeModelsSub();
      })
    );
  }

  /**
   * To handle add page popup
   */
  addNewPage() {
    const container = new Container();
    container.type = 1;
    container.iconClass = "1";
    container.parentContainerId = this.container.id;
    container.isDraftMode = this.container.isCurrentPageInDraftMode;
    const initialState = {
      container,
      verb: "Add",
      playbookId: this.commService.Playbook.id,
      companyId: this.commService.Playbook.companyId,
      profileId: this.loggedInProfile.id,
      pageId: this.container.id,
      draftMode: this.isCurrentPageInDraftMode,
      languageId: this.languageId,
      templateUrl: this.templateUrl,
    };
    this.addPageModalRef = this.modalService.show(
      AddPageComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
    this.modalSubscription.push(
      this.addPageModalRef.content.addContainer.subscribe((data) => {
        this.container.containers.push(data);
        this.seperateContainer();
        this.unsubscribeModelsSub();
      }),
      this.addPageModalRef.content.pasteContainer.subscribe(async (data) => {
        this.getPlaybookManifest();
        this.unsubscribeModelsSub();
      })
    );
  }

  /**
   * To handle edit page popup
   * @param cont update container
   */
  editContainer(cont) {
    const container = new Container();
    merge(container, cont);

    const initialState = {
      container,
      verb: "Edit",
      playbookId: this.commService.Playbook.id,
      companyId: this.commService.Playbook.companyId,
      profileId: this.loggedInProfile.id,
      pageId: this.container.id,
      draftMode: this.isCurrentPageInDraftMode,
      languageId: this.languageId,
      templateUrl: this.templateUrl,
      draftSections: this.list.draftSection,
    };
    this.addPageModalRef = this.modalService.show(
      AddPageComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
    this.modalSubscription.push(
      this.addPageModalRef.content.removeContainer.subscribe((data) => {
        this.container.containers = reject(
          this.container.containers,
          (eachCont) => eachCont.id === container.id
        );
        if (data.isSection && data.deleteDraftSection) {
          this.container.containers = reject(
            this.container.containers,
            (eachCont) => eachCont.refContainerId === container.id
          );
        }
        this.seperateContainer();
        this.unsubscribeModelsSub();
      }),
      this.addPageModalRef.content.updateContainer.subscribe(
        (data: Container) => {
          if (data.isPoolingNeeded) {
            this.getPlaybookManifest(data.isDraftMode);
          } else {
            if (this.languageId === this.defaultLanguageId) {
              const containerIndex = findIndex(
                this.container.containers,
                (eachCont) => eachCont.id === data.id
              );
              this.container.containers[containerIndex] = {
                ...this.container.containers[containerIndex],
                customIconAssetId: data.customIconAssetId,
                cutomIconAsset: data.cutomIconAsset,
                iconClass: data.iconClass,
                isDeleted: data.isDeleted,
                isDraftMode: data.isDraftMode,
                isShaded: data.isShaded,
                orderBy: data.orderBy,
                title: data.title,
                previewImageId: data.previewImageId,
              };
            } else {
              const containerIndex = findIndex(
                this.container.containers,
                (eachCont) => eachCont.id === data.id
              );
              this.container.containers[containerIndex].title = data.title;
            }
          }
          this.seperateContainer();
          this.unsubscribeModelsSub();
        }
      )
    );
  }

  /**
   * To open apply page template modal
   */
  openApplyTemplateModal() {
    const initialState = {
      companyId: this.companyId,
      pageId: this.container.id,
      playbookId: this.playbookId,
      isDraftMode: this.container.isCurrentPageInDraftMode,
      pageFrom: this.pageFrom,
    };
    this.applyPageTempRef = this.modalService.show(
      ApplyPageTemplateComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
    const path = window.location.pathname;
    if (path.indexOf("pagetemplate/choose") === -1) {
      const url =
        path +
        `/pagetemplate/choose?languageId=${this.languageId}${
          this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
        }`;
      this.location.go(url);
      this.sendIframeUrlService.sendUrlToParent(url);
    }
  }

  /**
   * To open copy page as template modal
   */
  openCopyTemplateModal() {
    const initialState = {
      profile: this.loggedInProfile,
      companyId: this.companyId,
      pageId: this.container.id,
      playbookId: this.playbookId,
      isDraftMode: this.container.isCurrentPageInDraftMode,
    };
    this.copyPageTempRef = this.modalService.show(
      CopyPageTemplateComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
    const path = window.location.pathname;
    if (path.indexOf("pagetemplate") === -1) {
      const url = path + "/pagetemplate" + "?languageId=" + this.languageId;
      this.location.go(url);
      this.sendIframeUrlService.sendUrlToParent(url);
    }
  }

  /**
   * To open playbook custom css modal
   */
  openPlaybookCssModal() {
    const initialState = {};
    this.customCssRef = this.modalService.show(
      PlaybookCustomCssComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
  }

  /**
   * To open Mobile Editor
   */
  openMobilePage() {
    this.showMobileEditor = !this.showMobileEditor;
    localStorage.setItem("mobileEditor", JSON.stringify(this.showMobileEditor));
    this.commService.sendSelectedContentBox(false);
    if (!this.showMobileEditor) {
      this.commService.setPlaybookManifest(PlaybookManifest.NONE);
    }
  }

  /*
   * show add content block menu.
   */
  showBlockMenuFunc() {
    if (!this.isServerProcess) {
      this.contentBoxShow = !this.contentBoxShow;
      this.isCopyPasteContentExist = this.commService.getCopyContentExists();
      this.commService.sendSelectedContentBox(this.contentBoxShow);
      this.commService.sendSelectedContentBlockId(null);
      this.commService.sendSelectedRowId(null);
      // TODO: patch inner page shows double content box
      this.isContentBoxOpened = true;
    }
  }

  /**
   * To open mail for playbook support
   */
  openSupportMail() {
    window.open("mailto:help@corporatevisions.com", "_blank");
  }

  isServerProcessFunc() {
    this.commService
      .getServerProcess()
      .subscribe((isServerProcess) => (this.isServerProcess = isServerProcess));
  }

  onDragStart(e, isCopyPaste = false) {
    if (isCopyPaste) {
      this.contentRow = this.isCopyPasteContentExist.contentType;
    } else {
      this.contentRow = null;
    }
    this.commService.setContentType(this.contentRow);
  }
  onDragEnd(e) {
    this.contentRow = null;
    const d = $(".dndDragover");
    this.contentBoxShow = false;
    this.utilService.clearAllBorderClasses();
  }

  onDragMoved(e) {
    const d = $(".dndDragover");
    d.first().removeClass("dndDragover");
    this.contentBoxShow = false;
    this.utilService.clearAllBorderClasses();
    this.contentBoxShow = true;
  }

  onDrag(e: DragEvent, isRowCopied = false) {
    if (this.contentBoxShow) {
      this.commService.sendSelectedContentBox(false);
    }
    if (!this.isFireFox && !this.isEdge) {
      const ui = {
        offset: {
          top: e.y,
          left: e.x,
        },
      };
      this.contentBoxShow = false;
      const t = $(e.target);
      const d = $(".dndDragover");
      if (e.x && e.y) {
        if (d.length === 0) {
          this.utilService.clearAllBorderClasses();
        }
        if (d.length > 1) {
          d.first().removeClass("dndDragover");
        }
        if (d.hasClass("norow")) {
          this.utilService.applyBorderClass(d, "top-hover");
        } else {
          if (d.length > 0) {
            this.utilService.detectAndAddHoverClass(d, ui, t);
          }
        }
      }
    }
  }

  clearSelectedEditor(isHideContentBox) {
    this.commService.sendSelectedContentBlockId(null);
    this.commService.sendSelectedRowId(null);
    if (isHideContentBox) {
      this.commService.sendSelectedContentBox(false);
    }
  }

  // check for draft
  checkForDisplayDraft = (container: Container) => {
    let returnFlag = 0;
    // for page as draft  /// check if contaniner.isDraft && isCurrentPageInDraftMode
    if (this.isParentPageInDraftMode && !container.isCurrentPageInDraftMode) {
      returnFlag = 2;
    } else {
      if (
        !container.isCurrentPageInDraftMode &&
        (this.list.draftSection.length === 0 ||
          this.list.draftPages.length === 0) &&
        !!(this.list.sections.length || this.list.pages.length)
      ) {
        returnFlag = 1; // if no previous draft present
      }
      if (
        !container.isCurrentPageInDraftMode &&
        !!(this.list.draftSection.length || this.list.draftPages.length)
      ) {
        returnFlag = 2; // if there are previous drafts are there
      }
    }
    return returnFlag;
  };
  createDraftMode(container: Container) {
    this.commonHttpService
      .get({
        uri: `/api/PlaybookDraft/GetDraftContainerStatus?playbookId=${+container.playbookId}&pageId=${+container.id}`,
      })
      .subscribe((response) => {
        if (response === ResponseDraftStatus.Error) {
          this.commonHttpService
            .delete({
              uri: `/api/PlaybookDraft/DeleteAllDraftSectionsForPage?playbookId=${+container.playbookId}&pageId=${+container.id}`,
              message: {
                showMessage: false,
              },
            })
            .subscribe(
              (responseData) => {
                if (this.checkForCurrentContainer(container)) {
                  this.showAlertForDraftMode(true);
                }
              },
              (error) => {
                if (this.checkForCurrentContainer(container)) {
                  this.showAlertForDraftMode(true);
                }
              }
            );
        } else if (response === ResponseDraftStatus.Complete) {
          this.communicationService.setShowHideLoader({
            loaderId: "simpleLoader",
            text: "",
            isShow: false,
          });
          if (this.checkForCurrentContainer(container)) {
            this.showAlertForDraftMode(true);
          }
        } else {
          this.messageService.showInfoMessage(
            "Please wait while the draft page is being created."
          );
        }
      });
  }
  viewActiveDraft(container) {
    if (this.checkForCurrentContainer(container)) {
      this.showAlertForDraftMode(false);
    }
  }
  // this function will check if the page is current tab is not
  checkForCurrentContainer(container) {
    return this.selectedPageId === container.id ? true : false;
  }
  showAlertForDraftMode(flag) {
    const initialState = {
      msg: "You are now working on a draft of this content. Your changes will not be live until you apply this draft to this playbook.",
    };
    this.confirmationModalRef = this.modalService.show(
      ConfirmationModelComponent,
      Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
    );
    this.confModalSubsciber =
      this.confirmationModalRef.content.onclose.subscribe(
        (isDraftMode: boolean) => {
          if (isDraftMode) {
            this.container.isCurrentPageInDraftMode = true;
            this.isCurrentPageInDraftMode = true;
            this.commService.setDraftStatus({
              pageId: this.container.id,
              isPageDraftMode: this.container.isCurrentPageInDraftMode,
            });
            if (flag) {
              this.enableDraftMode();
            }
          }
          this.confirmationModalRef.hide();
          this.confModalSubsciber.unsubscribe();
        }
      );
  }
  enableDraftMode() {
    this.commonHttpService
      .post({
        uri: `/api/PlaybookDraft/CreateDraftForPage`,
        object: {
          playbookId: +this.activatedRoute.snapshot.params.playbookId,
          pageId: this.selectedPageId,
        },
      })
      .subscribe((createDraftResponse) => {
        if (createDraftResponse) {
          this.communicationService.setShowHideLoader({
            loaderId: "simpleLoader",
            text: "",
            isShow: true,
          });
          this.unSubscribeCheckFileStatus();
          this.checkDraftStatus$ = timer(1, 10000).pipe(
            switchMap(() => this.checkDraftStatus()),
            retry(1)
          );
          this.checkDraftStatusSubscription$ = this.checkDraftStatus$.subscribe(
            (response) => {
              if (response === ResponseDraftStatus.Error) {
                // Error comes
                this.communicationService.setShowHideLoader({
                  loaderId: "simpleLoader",
                  text: "",
                  isShow: false,
                });
                this.unSubscribeCheckFileStatus();
                this.container.isCurrentPageInDraftMode = false;
                this.isCurrentPageInDraftMode = false;
                this.messageService.showErrorMessage(
                  "Something went wrong while processing your request"
                );
              } else if (response === ResponseDraftStatus.Complete) {
                // No record found
                this.communicationService.setShowHideLoader({
                  loaderId: "simpleLoader",
                  text: "",
                  isShow: false,
                });
                this.unSubscribeCheckFileStatus();
                this.container.isCurrentPageInDraftMode = true;
                this.isCurrentPageInDraftMode = true;
                this.commService.setDraftStatus({
                  pageId: this.container.id,
                  isPageDraftMode: this.container.isCurrentPageInDraftMode,
                });
                this.getPlaybookManifest(
                  this.container.isCurrentPageInDraftMode
                );
                this.messageService.showSuccessMessage(
                  "Draft created successfully"
                );
              } else {
              }
            }
          );
        }
      });
  }
  getPlaybookManifest(isDraftMode?: boolean, undoRedoSectionData?: any) {
    if (this.playbookId) {
      this.commonHttpService
        .get<any>({
          uri: `/api/Playbooks/GetFullPlaybookManifest?playbookId=${
            this.playbookId
          }&languageId=${
            this.languageId === this.defaultLanguageId ? null : this.languageId
          }`,
        })
        .subscribe((response) => {
          const playbookData = JSON.parse(response.json);
          this.commService.Playbook = playbookData;
          if (undoRedoSectionData) {
            this.setPageSectionsOn(
              undoRedoSectionData.sectionId ? undoRedoSectionData.sectionId : -1
            );
            this.commService.sendCurrentSectionId(
              undoRedoSectionData.sectionId
                ? undoRedoSectionData.sectionId
                : null
            );
            this.commService.sendCurrentPageId(
              undoRedoSectionData.pageId ? undoRedoSectionData.pageId : -1
            );
            const url = `/playbookeditor/${undoRedoSectionData.playbookId}${
              undoRedoSectionData.pageId
                ? "/page/" +
                  undoRedoSectionData.pageId +
                  "/section/" +
                  undoRedoSectionData.sectionId
                : ""
            }?languageId=${this.languageId}${
              this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
            }${this.templateUrl ? "&templateUrl=" + this.templateUrl : ""}${
              this.pageFrom ? "&pageFrom=" + this.pageFrom : ""
            }`;
            this.location.go(url);
            this.sendIframeUrlService.sendUrlToParent(url);
          } else if (!isDraftMode) {
            this.setPageSectionsOn(-1);
            this.commService.sendCurrentPageId(-1);
            this.commService.sendCurrentSectionId(null);
            this.container.isCurrentPageInDraftMode = isDraftMode;
            this.isCurrentPageInDraftMode = isDraftMode;
            this.commService.setDraftStatus({
              pageId: this.container.id,
              isPageDraftMode: false,
            });
          } else if (isDraftMode) {
            this.setPageSectionsOn(-1);
            this.commService.sendCurrentPageId(-1);
            this.commService.sendCurrentSectionId(null);
            this.commService.setDraftStatus({
              pageId: this.container.id,
              isPageDraftMode: isDraftMode,
            });
          }
        });
    }
  }

  checkDraftStatus(): Observable<any> {
    return this.commonHttpService.get({
      uri: `/api/PlaybookDraft/GetDraftContainerStatus?playbookId=${this.playbookId}&pageId=${this.selectedPageId}`,
    });
  }
  unSubscribeCheckFileStatus() {
    if (this.checkDraftStatusSubscription$) {
      this.checkDraftStatusSubscription$.unsubscribe();
    }
  }
  leaveDraftMode(container) {
    if (this.checkForCurrentContainer(container)) {
      this.container.isCurrentPageInDraftMode = false;
      this.isCurrentPageInDraftMode = false;
      this.commService.setDraftStatus({
        pageId: this.container.id,
        isPageDraftMode: this.container.isCurrentPageInDraftMode,
      });
    }
  }

  openDraftModal() {
    this.commonHttpService
      .get<Array<SectionsForPageViewModel>>({
        uri: `/api/PlaybookDraft/GetAllSectionsForPage?playbookId=${this.playbookId}&pageId=${this.selectedPageId}`,
      })
      .subscribe((allSections) => {
        const initialState = {
          allSections,
          playbookId: this.playbookId,
          pageId: this.selectedPageId,
          draftPages: this.list.draftPages,
        };
        this.draftModalRef = this.modalService.show(
          ApplyDraftComponent,
          Object.assign(
            { initialState },
            { class: "custom-modal" },
            Modalconfig
          )
        );
        this.modalSubscription.push(
          this.draftModalRef.content.draftSaved.subscribe((isDraftMode) => {
            this.getPlaybookManifest(isDraftMode);
            this.unsubscribeModelsSub();
          }),
          this.draftModalRef.content.draftDeleted.subscribe(
            (isDraftDeleted) => {
              this.getPlaybookManifest(false);
              this.unsubscribeModelsSub();
            }
          )
        );
      });
  }
  unsubscribeModelsSub() {
    this.modalSubscription.forEach((sub) => {
      sub.unsubscribe();
    });
    this.modalSubscription = [];
  }

  /**
   * returns playbook viewer's url
   */
  copyViewerLinkToClipboard(): string {
    return window.location.href.replace("/playbookeditor", "/playbook");
  }
  notify(event: string): void {
    this.messageService.showSuccessMessage(
      "URL successfully copied to your clipboard."
    );
  }

  undoRedoPopUp() {
    const initialState = {
      languageId: this.languageId,
      playbookId: this.playbookId,
      vBuilderRedirectURl: this.vBuilderRedirectURl,
      templateUrl: this.templateUrl,
      pageFrom: this.pageFrom,
    };
    this.modalRef = this.modalService.show(
      UndoRedoComponent,
      Object.assign(
        { initialState },
        { class: "custom-modal custom-modal-md" },
        Modalconfig
      )
    );
  }

  copyCurrentPage() {
    this.commonHttpService
      .post({
        uri: `/api/Playbooks/CopyPlaybookPage`,
        object: {
          playbookId: this.playbookId,
          profileId: this.loggedInProfile.id,
          pageId: this.container.id,
        },
        message: {
          showMessage: true,
          successMessage: "Page successfully copied to your clipboard.",
          errorMessage: "Something went wrong while Copying page.",
        },
      })
      .subscribe((response) => this.commService.setCopyPageExists(true));
  }

  displayChangesSaved() {
    if (!this.updatingTextBlock && !this.updatingTab) {
      this.playbookToastService.displayToast({
        content: "Playbook changes saved successfully.",
        duration: 1500,
      });
    }
  }

  ngOnDestroy() {
    if (this.modalSubscription.length > 0) {
      this.unsubscribeModelsSub();
    }
    if (this.navContainerUpdateSubscription) {
      this.navContainerUpdateSubscription.unsubscribe();
    }
    if (this.sectionIdSubscriber) {
      this.sectionIdSubscriber.unsubscribe();
    }
    if (this.pageIdSubscribed) {
      this.pageIdSubscribed.unsubscribe();
    }
    if (this.subscribed) {
      this.subscribed.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.contRatingsSubscription) {
      this.contRatingsSubscription.unsubscribe();
    }
    if (this.showContentBoxSubscription) {
      this.showContentBoxSubscription.unsubscribe();
    }
    if (this.getUpdatingTextBlockSub) {
      this.getUpdatingTextBlockSub.unsubscribe();
    }
    if (this.getUpdatingTabSub) {
      this.getUpdatingTabSub.unsubscribe();
    }
  }
}
